module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/309.df3226ce.png";